import React from "react";
import { Outlet } from "react-router-dom";

const NetworkManagementRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default NetworkManagementRoot;
